import React from 'react';
import { Divider } from '@infoods/lifebase-ui';

import { observer } from 'mobx-react';

import classes from './GrossRevenueSummary.module.scss';
import { GrossRevenueSummaryItem } from './GrossRevenueSummaryItem/GrossRevenueSummaryItem';
import { GrossRevenueInfo } from '../../../../interfaces/entity-dashboard/GrossRevenueData';
import { entityDashboardFilterStore } from '../../../../stores/entityDashboardFilterStore';
import { getComparisonPeriodForPreset } from '../../../../../shared/utils/getComparisonPeriodForPreset/getComparisonPeriodForPreset';
import { getTitleForPreset } from '../../../../../shared/utils/getTitleForPreset/getTitleForPreset';

type GrossRevenueSummaryProps = {
  currentPeriodRevenue: GrossRevenueInfo;
  previousPeriodRevenue: GrossRevenueInfo;
};

const GrossRevenueSummary = observer(
  ({ currentPeriodRevenue, previousPeriodRevenue }: GrossRevenueSummaryProps) => {
    const { dateRangePreset } = entityDashboardFilterStore;

    return (
      <div className={classes.container}>
        <GrossRevenueSummaryItem
          title={getTitleForPreset(dateRangePreset, 'Revenue this')}
          value={currentPeriodRevenue.value}
          diffPercent={currentPeriodRevenue.diffPercent}
          indicatorColor="green"
          period={getComparisonPeriodForPreset(dateRangePreset)}
        />
        <Divider />
        <GrossRevenueSummaryItem
          title={getTitleForPreset(dateRangePreset, 'Revenue previous')}
          value={previousPeriodRevenue.value}
          diffPercent={previousPeriodRevenue.diffPercent}
          indicatorColor="gray"
        />
      </div>
    );
  },
);

export { GrossRevenueSummary };
